import type { Location } from 'history';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';

export const usePreviousLocation = () => {
  const { location } = useHistory();
  const [{ previous, current }, setState] = useState<{
    previous?: Location;
    current: Location;
  }>({ current: location });

  if (current.pathname !== location.pathname) {
    setState({ previous: current, current: location });
  }

  return previous?.pathname;
};
